export type CallColumnId =
  | "direction" | "phone" | "schedule" | "agent" | "version" | "voice" | "duration" | "timestamp"
  | "status" | "rec" | "pca" | "hungBy" | "campaign" | "sentiment" | "executionId";

export const CALL_COLUMNS: { id: CallColumnId; label: string }[] = [
  // Direction (Inbound vs Outbound)
  { id: "direction", label: "Direction" },
  // Phone is its own column and only offered when the account may see customer
  // numbers (admin's "Show Customer Phone"); Schedule ID always stands alone, so
  // it stays readable instead of collapsing to a bare copy button when the
  // number is redacted server-side.
  { id: "phone", label: "Phone" },
  { id: "schedule", label: "Schedule ID" },
  { id: "agent", label: "Agent" },
  { id: "version", label: "Version" },
  { id: "voice", label: "Voice" },
  { id: "duration", label: "Duration" },
  { id: "timestamp", label: "Timestamp" },
  { id: "status", label: "Status" },
  { id: "rec", label: "Recording" },
  { id: "pca", label: "Analysis" },
  { id: "hungBy", label: "Hung By" },
  { id: "campaign", label: "Campaign" },
  { id: "sentiment", label: "Sentiment" },
  { id: "executionId", label: "Execution ID" },
];

export const DEFAULT_CALL_COLUMNS: CallColumnId[] = CALL_COLUMNS.map((c) => c.id);

export type ColumnId = "contactId" | CallColumnId;

export const DEFAULT_COLUMN_WIDTHS: Record<ColumnId, number> = {
  contactId: 155,
  direction: 110,
  phone: 140,
  schedule: 160,
  agent: 165,
  version: 85,
  voice: 130,
  duration: 95,
  timestamp: 155,
  status: 120,
  rec: 90,
  pca: 110,
  hungBy: 105,
  campaign: 155,
  sentiment: 115,
  executionId: 150,
};

export const MIN_COLUMN_WIDTHS: Record<ColumnId, number> = {
  contactId: 90,
  direction: 80,
  phone: 90,
  schedule: 90,
  agent: 90,
  version: 60,
  voice: 80,
  duration: 70,
  timestamp: 100,
  status: 80,
  rec: 75,
  pca: 85,
  hungBy: 80,
  campaign: 90,
  sentiment: 85,
  executionId: 90,
};
